// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6216) return "static/chunks/6216.fa47ffc9300bd001.js";
	if (chunkId === 240) return "static/chunks/c36f3faa.9eeb71250fde1828.js";
	if (chunkId === 6911) return "static/chunks/6911.7037c4b4b7159abc.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"594":"8ffc485e","3768":"473d9b3e","8924":"d5ad3d22"}[chunkId] || chunkId) + "-" + {"536":"a1c9cb3061463f61","594":"92732924bc858831","3768":"042435b8ae832de6","4662":"9d8f012383c85b1d","8189":"b39d12fec85c5981","8548":"c981363eee5dce20","8924":"18a1d2deb72320b7"}[chunkId] + ".js";
};